import type { DarkenerComponent } from './models/DarkenerComponent';
import style from './styles/App.module.scss';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

interface DarkenerProps {
    switchOff: EventListener,
    darken?: number
}

const THIRTY_PERCENT = 0.3;

const Darkener = forwardRef<DarkenerComponent, DarkenerProps>(({ switchOff, darken = THIRTY_PERCENT }, ref) => {
    const [isShowing, setIsShowing] = useState<boolean>(false);
    const theBox = useRef<HTMLDivElement>(null);

    const activate = () => {
        setIsShowing(true);
        theBox.current.addEventListener('click', switchOff);
    };

    const deactivate = () => {
        setIsShowing(false);
        theBox.current.removeEventListener('click', switchOff);
    };

    useImperativeHandle(
        ref,
        () => ({
            enable: activate,
            disable: deactivate
        }),
        []
    );
    return <div className={`${ style.darkener } ${ isShowing ? style.on : '' }`} style={{ backgroundColor: `rgba(0, 0, 0, ${ darken }` }} ref={theBox} />;
});

Darkener.displayName = 'Darkener';

export default Darkener;